import React, { useState } from "react";
import { Heading, Subheading } from "../../../design/heading";
import { Button } from "../../../design/button";
import { useUser } from "../../../contexts/UserContext";
import { useMatter } from "../../../contexts/MatterContext";
import { Text } from "../../../design/text";
import { useMatterType } from "../../../contexts/MatterTypeContext";
import { useIntake } from "../../../contexts/IntakeContext";
import { useNavigate } from "react-router-dom";
import LogoHorizontal from "../../../components/LogoHorizontal";
import { useTenant } from "../../../contexts/TenantContext";

interface Props {
  onBack: () => void;
}

const MatterTypeStep: React.FC<Props> = ({ onBack }) => {
  const { tenant } = useTenant();
  const { createIntake } = useIntake();
  const { matterTypes } = useMatterType();
  const navigate = useNavigate();
  const { currentMatter, setCurrentMatterId } = useMatter();
  const [matterType, setMatterType] = useState<string>(
    localStorage.getItem("matterType") || "",
  );

  const handleSubmit = async () => {
    // if (!matterType) return;
    // const intakeId = await createIntake({
    //   matterType: matterType,
    // });
    // navigate(`/intake/${intakeId}`);
  };

  const handleContinueWithMatter = async () => {};

  const handleStartNewMatter = async () => {
    localStorage.removeItem("currentMatterId");
    localStorage.removeItem("matterType");
    localStorage.removeItem("intakeId");
    setCurrentMatterId(null);
  };

  const filteredMatterTypes = matterTypes.filter((a) => a.isPrivate === false);

  return (
    <div className="items-center text-center">
      <div>
        {currentMatter && (
          <div>
            <Heading>You are currently working on the following matter</Heading>
            <Subheading>{currentMatter.identifier}</Subheading>
            <Text>Do you wish to continue or start something new?</Text>
            <div className="flex flex-row items-center justify-center w-full mt-4 space-x-4">
              <Button
                className="w-full"
                onClick={handleContinueWithMatter} // Continue with current matter
              >
                Continue with current matter
              </Button>
              <Button
                className="w-full"
                onClick={handleStartNewMatter} // Reset current matter and start a new one
              >
                Start a new matter
              </Button>
            </div>
          </div>
        )}
        {!currentMatter && (
          <div className="flex flex-col items-center justify-center w-full max-w-3xl p-6 mx-auto mt-8">
            <LogoHorizontal
              tenant={tenant}
              className="w-1/2 max-w-[300px] mb-4"
            />
            <Heading>What can we help you with today?</Heading>
            <Subheading>Please select one of the following:</Subheading>
            <div className="grid justify-center w-full max-w-3xl grid-cols-1 gap-4 mt-8 sm:grid-cols-2 md:grid-cols-3">
              {filteredMatterTypes.map((value) => (
                <div
                  key={value._id}
                  className={`flex flex-col items-center w-full p-6 rounded-lg shadow-md cursor-pointer transition-colors ${
                    matterType === value._id
                      ? "bg-blue-100 dark:bg-blue-900"
                      : "bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700"
                  }`}
                  onClick={() => {
                    setMatterType(value._id);
                  }}
                >
                  {/* <img
                    src={assets[key as keyof typeof assets]}
                    alt={key}
                    className="w-24 h-24 mb-3"
                  /> */}
                  <Subheading>{value.name}</Subheading>
                </div>
              ))}
            </div>
            <div className="flex items-end w-full mt-8 space-x-4">
              <Button plain className="w-full" onClick={onBack}>
                Back
              </Button>
              <Button
                className="w-full"
                onClick={handleSubmit}
                disabled={!matterType}
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MatterTypeStep;
